import { useEffect } from 'react';
import { useUser } from '@/data/user';
import { useBootstrapData } from '@/data/user/bootstrap-data';
import { identify } from '@/utils/analytics';

export const useAnalyticsIdentity = (enabled = true) => {
  const { user } = useUser(enabled);
  const { bootstrap } = useBootstrapData(enabled);

  useEffect(() => {
    if (!user || !bootstrap) return;

    const { plan, experiments } = bootstrap;

    identify({
      id: user.id,
      name: user.nome,
      email: user.email,
      companyId: user.colaborador?.empresa_id,
      plan,
      experiments: Object.values(experiments ?? {}).map(
        (experiment) =>
          `${experiment.experiment_slug}:${experiment.bucket_slug}`
      ),
      permissions: user.permissoes?.map((permission) => permission.nome) ?? [],
    });
  }, [user, bootstrap]);
};
